import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFooter,{attrs:{"color":"#00b1caff","app":""}},[_c('span',{staticClass:"white--text"},[_vm._v("Contact @ https://github.com/hannesortmeier/dicer")])])
}
var staticRenderFns = []

export { render, staticRenderFns }